import { AudioLines, Settings2 } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";
export type { Origin } from "./NewTranscription";
export type { MinutesDraft } from "./Minutes";

/** Painel "Gravação e transcrição" da página da reunião (agenda), carregado sob demanda: use dentro de um Suspense. */
export const MeetingTranscriptions = lazyPage(() => import("./MeetingTranscriptions"), "MeetingTranscriptions");

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const TranscriptionsPage = lazyPage(() => import("./TranscriptionsPage"), "TranscriptionsPage");
const TranscriptionPage = lazyPage(() => import("./TranscriptionPage"), "TranscriptionPage");
const SettingsPage = lazyPage(() => import("./SettingsPage"), "SettingsPage");

/**
 * Transcrição de reuniões: Relacionamento → Transcrições (gravações viram texto com quem falou e quando, ata com IA e
 * exportação) e Configurações → Transcrição (servidor Whisper próprio, serviços externos, limites e retenção). A página
 * da reunião da agenda mostra o painel "Gravação e transcrição" quando este módulo está ligado.
 */
export default defineModuleUi({
  key: "transcription",
  title: "Transcrição de reuniões",
  domain: "relationship",
  icon: AudioLines,
  menu: [
    {
      path: "/relacionamento/transcricoes", label: "Transcrições", minRole: "member", icon: AudioLines, order: 32,
      keywords: "transcrição gravação reunião áudio vídeo meet zoom teams jitsi whisper falantes legenda srt vtt ata",
    },
    {
      path: "/configuracoes/transcricao", label: "Transcrição", minRole: "admin", icon: Settings2, domain: "platform", order: 62,
      keywords: "whisper servidor motor transcrição openai groq deepgram assemblyai elevenlabs gladia speechmatics azure mistral retenção",
    },
  ],
  routes: [
    { path: "/relacionamento/transcricoes", element: <TranscriptionsPage />, minRole: "member" },
    { path: "/relacionamento/transcricoes/:id", element: <TranscriptionPage />, minRole: "member" },
    { path: "/configuracoes/transcricao", element: <SettingsPage />, minRole: "admin" },
  ],
});
